<wchfs-icon svgIcon="pso-legacy:info_orange_ico" size="24"></wchfs-icon>
<p [style.text-align]="textAlign"><ng-content></ng-content></p>
